export var getProductUrl = function getProductUrl(code) {
  return "/products/product?code=".concat(code);
};
//# sourceMappingURL=getProductUrl.js.map